import './Tile.css'

/**
 * A single headline number.
 *
 * Four numbers are not a chart. A hero figure reads faster than any mark that
 * could carry it, and a bar chart of four unrelated totals invites comparisons
 * between quantities that share no scale.
 *
 * Tone goes on the left border rule, never the digits: a 27px figure in
 * warning-amber fails contrast against the card, and colouring the number is the
 * obvious thing that does not survive a contrast check.
 *
 * Extracted from ReportScreen so the dashboard reuses it rather than copying —
 * two near-identical tiles would drift, and the drift would show up as two
 * screens disagreeing about the same fleet.
 */
export function Tile({
  label,
  value,
  note,
  tone,
  href,
}: {
  label: string
  value: number | string | undefined
  note?: string
  tone?: 'crit' | 'warn' | 'ok' | 'unk'
  /** When given, the whole tile becomes a link into the register. */
  href?: string
}) {
  const body = (
    <>
      <span className="tile__label">{label}</span>
      <b className="tile__value mono">{value ?? 0}</b>
      {note && <span className="tile__note">{note}</span>}
    </>
  )

  const className = `tile${tone ? ` tile--${tone}` : ''}${href ? ' tile--link' : ''}`

  // An anchor only when it goes somewhere. A div dressed as a link that does
  // nothing is worse than a plain div.
  return href ? (
    <a className={className} href={href}>
      {body}
    </a>
  ) : (
    <div className={className}>{body}</div>
  )
}

